import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import cseFacultyData from "./facultyData/cseFacultyData";

const facultyDisplayNames = {
  "f-venkatesh-shankar": "Dr. Venkatesh S.",
  "f-farajanabegaum-nadaf": "Ms. Farzana N. Nadaf",
  "f-girish-n-shivanagudi": "Mr. Girish Shivanagudi",
  "f-vijet-swadi": "Mr. Vijeth Swadi",
  "f-nancy-p": "Mrs. Nancy Philip",
};

const facultyOrder = [
  "f-farajanabegaum-nadaf",
  "f-shree-gowri-s-s",
  "f-pranesh-kulkarni",
  "f-girish-n-shivanagudi",
  "f-bhagat-inamdar",
  "f-sunita-kallu",
  "f-nirmala-ganiger",
  "f-vijet-swadi",
  "f-nancy-p",
  "f-apoorva-sabnis",
  "f-samyukta-guddin",
  "f-vijaylaxmi-b-vyakaranahal",
  "f-rakesh-patil",
];

const withDisplayName = (faculty) => ({
  ...faculty,
  name: facultyDisplayNames[faculty.id] || faculty.name,
});

const facultyData = {
  ...cseFacultyData,
  hod: withDisplayName(cseFacultyData.hod),
  members: facultyOrder
    .map((id) => cseFacultyData.members.find((faculty) => faculty.id === id))
    .filter(Boolean)
    .map(withDisplayName),
};

export const programme = {
  id: "cse",
  name: "Computer Science & Engineering",
  short: "CSE",
  programmeType: "ug",
  programmeLabel: "B.E.",
  duration: "4 Years (8 Semesters)",
  intake: 120,
  // studentsEnrolled: 0,
  // facultyStrength: 12,
  // phdFaculty: 1,
  established: 2004,
  description:
    "The Department of Computer Science and Engineering (CSE) at KLS Vishwanathrao Deshpande Institute of Technology (KLS VDIT), Haliyal, established in 2004 with the vision of imparting quality technical education and producing competent computer science professionals capable of addressing the challenges of the rapidly evolving digital world. Since its inception, the department has been dedicated to academic excellence, innovation, research, and holistic student development.",
  image: "/Infrastructure/CSE/3.jpg",
  hodId: "f-venkatesh-shankar",
  facultyData,
  labs: [
    "C Programming Lab",
    "Database Lab",
    "Networks Lab",
    "Cyber Security Lab",
    "Machine Learning Lab",
    "Project Lab",
    "Latex Lab",
  ],
  research:
    "Artificial Intelligence, Data Science, Internet of Things, Cybersecurity, Software Development, Cloud Computing",
  // researchFundedProjects: 2,
  accreditation: [
    "AICTE Approved Intake: 120 seats",
    "VTU Affiliated since 2004",
    "VTU Recognized Research Centre",
  ],
  achievements: [
    {
      title: "Achievement Documents",
      items: [
        {
          label: "Introduction to Internet of Things Certificate- Farjanabegum Nadaf",
          href: "/Achievements/CSE/Introduction-to-Internet-of-Things-1.pdf"
        },
        {
          label: "Introduction to Internet of Things Certificate- Shree Gowri S S",
          href: "/Achievements/CSE/Introduction-to-Internet-of-Things-NPTEL-Certificate.pdf"
        },
        {
          label: "Introduction to Internet of Things Certificate- Nirmala Ganiger",
          href: "/Achievements/CSE/Introduction-to-Internet-of-Things.pdf"
        },
        {
          label: "IdeaThon Certificate- Supreet Chinnannavar",
          href: "/Achievements/CSE/Ideathonsupreet-1.pdf"
        },
      ],
    },
  ],
  newsEvents: {
    // news: [
    //   {
    //     id: "cse-news-1",
    //     title: "CSE Department Activities",
    //     date: "2025-26",
    //     image: "/Infrastructure/CSE/3.jpg",
    //     excerpt: "Department news and activity updates from Computer Science & Engineering.",
    //   },
    // ],
    // events: [
    //   {
    //     id: "cse-event-1",
    //     title: "Technical Talk and Student Activities",
    //     date: "2025-26",
    //     time: "Department Activity",
    //   },
    // ],
    reports: [
      { label: "Basics of Cloud Computing", href: "/EVENTS/CSE/Basics-of-cloud-computing.pdf" },
      { label: "Cyber Security Tech Talk", href: "/EVENTS/CSE/Cyber-Security-tech-talk-report-1.pdf" },
    ],
  },
  projects: [
    {
      title: "Student Innovation Projects",
      funding: "Department activity",
      amount: "To be updated",
    },
    {
      title: "Industry Connect and MoU Activities",
      funding: "Department activity",
      amount: "To be updated",
    },
  ],
  dashboard: [
    ["Faculty Members", "14"],
    ["Faculty with Ph.D.", "01"],
    ["Faculty pursuing Ph.D", "07"],
    ["Laboratories", "07"],
  ],
  academicVision:
    "To achieve excellence in technical education, research,  and innovation in computer 	science and Engineering by emphasizing on global trending technologies",
  academicOverview: [
    {
      title: "Academic Strengths",
      text:
        "The department offers a Bachelor of Engineering program in Computer Science and Engineering with an approved intake of 120 students. The curriculum follows VTU guidelines and is enriched through industry interaction, emerging technologies, and outcome-based education practices.",
    },
    {
      title: "Mission",
      text: [
        "To train students with conceptual understanding through innovative pedagogies.",
        "To imbibe professional, research, and entrepreneurial skills with a commitment to the nation's development at large.",
        "To strengthen the industry-institute interaction.",
        "To promote life-long learning with a sense of societal and ethical responsibilities.",
      ],
    },
    {
      title: "Beyond Syllabus",
      text:
        "The department enriches student learning through industry-focused certification programs, hackathons, coding competitions, technical workshops, internships, research and innovation activities, professional chapters such as CSI, ISTE, BITES, and Cisco Networking Academy (NetAcad), Centre of Excellence (CoE) in Cybersecurity, industry interactions, placement training, entrepreneurship support, and participation in national-level technical events, fostering practical skills, innovation, and career readiness beyond the university curriculum.",
    },
  ],
  curriculumSupport: [
    "Industry interaction through collaborations with industries, technology experts, and alumni.",
    "Internships, in-plant training, industrial visits, expert lectures, and live project opportunities bridge academic learning with real-world applications.",
    "A departmental library supports academic learning, project work, competitive examinations, and research activities.",
    "Students are encouraged to undertake innovative projects, participate in competitions, pursue certifications, and engage in research-oriented activities.",
    "The department promotes innovation, ethical values, entrepreneurship, and lifelong learning.",
    "Graduates are prepared for careers in multinational companies, government organizations, startups, higher education, and research.",
  ],
  programmeOutcomes: [
    "Engineering knowledge: Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.",
    "Problem analysis: Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using the first principles of mathematics, natural sciences, and engineering sciences.",
    "Design/development of solutions: Design solutions for complex engineering problems and design system components or processes that meet the specified needs with appropriate consideration for public health and safety and cultural, societal, and environmental considerations.",
    "Conduct investigations of complex problems: Use research-based knowledge and research methods including design of experiments, analysis, interpretation of data, and synthesis of the information to provide valid conclusions.",
    "The engineer and society: Apply to reason informed by the contextual knowledge to assess societal, health, safety, legal and cultural issues and the consequent responsibilities relevant to the professional engineering practice.",
    "Environment and sustainability: Understand the impact of professional engineering solutions in societal and environmental contexts and demonstrate the knowledge of and need for sustainable development.",
    "Ethics: Apply ethical principles and commit to professional ethics and responsibilities and norms of the engineering practice.",
    "Individual and team work: Function effectively as an individual and as a member or leader in diverse teams and in multidisciplinary settings.",
    "Communication: Communicate effectively on complex engineering activities with the engineering community and with society at large, such as being able to comprehend and write effective reports and design documentation, make effective presentations and give and receive clear instructions.",
    "Project management and finance: Demonstrate knowledge and understanding of the engineering and management principles and apply these to one’s own work, as a member and leader in a team, to manage projects and in multidisciplinary environments.",
    "Recognize the need for lifelong learning and adapt to technological changes in mechanical engineering and allied fields.",
  ],
  pso: [
    "Develop abilities to model real-world problems using appropriate algorithms, computational theories, and programming languages in the area of Computer Science and Engineering.",
    "Develop an ability to inculcate innovation, entrepreneurial, and leadership skills.",
  ],
  peo: [
    "Develop an ability to identify and analyze the requirements of Computer Science and Engineering in design and provide novel engineering solutions.",
    "Develop abilities to work in a team on multidisciplinary projects with effective communication skills, ethical qualities, and leadership roles.",
    "Develop abilities for a successful Computer Science Engineer and achieve higher career goals.",
  ],
  infrastructure: [
    ["Classrooms", "06"],
    ["Laboratories", "07"],
    ["Project Rooms", "06"],
    ["Computing Facilities", "500+ computers"],
    [
      "Software Tools",
      "Code::Blocks, Jupyter, LaTeX, TeXworks, MiKTeX, Arduino IDE, Keil, Oracle, Power BI, Notepad++, MongoDB",
    ],
    [
      "Equipment Highlights",
      "IoT kits and modern computing facilities for academic, laboratory, and project work.",
    ],
  ],
  infrastructureImages: [
    {
      src: "/Infrastructure/CSE/3.jpg",
      title: "CSE Infrastructure",
      alt: "Computer Science and Engineering department infrastructure",
    },
  ],
  hideSharedClubs: true,
  studentActivities: {
    clubs: [
      {
        name: "CISCO",
        category: "Professional Chapter",
        image: "/CSE_CLUB_LOGOS/CSE_CISCO.png",
        description:
          "CISCO activities expose students to networking, wireless technologies, security, cloud, collaboration, data center, virtualization, artificial intelligence, observability, software, and connected digital technologies.",
       reports: [
        { title: "CISCO", href: "/student-club/CSE/CISCO-2024-05-13.pdf" },
        // { title: "C-Force Report 2", href: "#" },
      ],
        },
      {
        name: "Infosys Springboard",
        category: "Professional Chapter",
        image: "/CSE_CLUB_LOGOS/CSE_CSI.png",
        description:
        "Student engagement, workshops, certifications, and technical activities through Infosys Springboard.",
       reports: [
        { title: "Infosys Springboard", href: "/student-club/CSE/INFOSYS SPRINGBOARD.pdf" },
        // { title: "C-Force Report 2", href: "#" },
      ],
      },
      {
        name: "ACM Student Chapter",
        category: "Professional Chapter",
        image: "/CSE_CLUB_LOGOS/CSE_ACM.png",
        description:
          "Student chapter Group id: 200565. The ACM Student Chapter at KLS VDIT provides a premier platform for students to explore modern computing, competitive programming, research, and global technical collaboration.",
        reports: [
          {
            title: "Technical Talk on DevOps Automation and CI/CD Pipeline",
            href: "/student-club/CSE/ACM/Technical-Talk-on-DevOps-Automation-and-CICD-Pipeline.pdf",
          },
          {
            title: "Technical Talk on Unlocking the Power of Data Science with Python",
            href: "/student-club/CSE/ACM/Technical-Talk-on-Unlocking-the-Power-of-Data-Science-With-Python.pdf",
          },
        ],
      },
      {
        name: "C-Force",
        category: "Student Club",
        description:
          "C-Force, the student association of the Computer Science and Engineering department, is a dynamic platform fostering academic excellence and technical empowerment through alumni interaction, expert-led talks, hands-on workshops, mentorship sessions, hackathons, project exhibitions, conferences, and technical events.",
        reports: [
          { title: "Freshers Party", href: "/student-club/CSE/CFORCE/SCAN_20260402_142644560-1.pdf" },
          { title: "Navigating the IT Industry", href: "/student-club/CSE/CFORCE/Technical-talk-on-Navigating-the-IT-Industry-on-12-09-2024.pdf" },
        ],
      },
    ],
  },
  featuredVideo: {
    title: "Department Video",
    sub: "A closer look at the CSE department",
    embedUrl: "https://www.youtube.com/embed/tgQTTNm5QdQ",
    iframeTitle: "CSE department video",
  },
  departmentContact: {
    name: "Dr. Venkatesh Shankar",
    role: "Head of Department",
    email: "hodcse@klsvdit.edu.in, vss@klsvdit.edu.in",
    phone: "9964145566",
  },
  nonTeachingStaff: [
    ["Mr. Vadiraj Udupi", "Foreman"],
    ["Mr. Virupaksh Melinmani", "Instructor"],
    ["Mr. Tanaji P. Magawadkar", "Instructor"],
    ["Mr. Manjunath K", "Asst. Instructor"],
    ["Mrs. Shivanni Dallal", "Asst. Instructor"],
    ["Mr. Vinayak Patil", "Asst. Instructor"],
    ["Mr. Amith B", "Asst. Instructor"],
    ["Mr. Raghavendra Konjali", "Mechanic"],
    ["Mr. Sanju Gowda", "Attender"],
    ["Mr. Suresh Madiwal", "Peon"],
    ["Mr. Chandru", "Peon"],
  ],
};

const CSE = () => <ProgrammeDetail programme={programme} />;

export default CSE;
